<template>
<div id="faqipay">
     <!-- 头部组件 -->
     <component :is="header_"></component>
     <!--  -->
    <el-container class="el-container-vh" style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <component :is="celan"></component>
      
      <el-container>
        <el-main>
             <div class="pays">
               <h3>
                 <fieldset style="border-width: 1px 0 0;font-size: 16px;">
                    <legend style="">
                        发起支付 / 创建订单
                    </legend>
                 </fieldset>
               </h3>
               <p>
                  跳转支付页接口URL： http://xxx.com/pay.php
               </p>
               <p>
                  传参方式：POST<br>
                  使用方法：用表单POST的方式，POST参数并跳转到此网址，显示支付页。
               </p>
             </div>
             <el-table
              :data="tableData1"
              style="width: 100%"
              row-key="id"
              border
              lazy
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column
                prop="date"
                label="参数名"
                width="180">
              </el-table-column>
              <el-table-column
                prop="name"
                label="含义"
                width="180">
              </el-table-column>
              <el-table-column
                prop="address"
                label="类型"
                width="180">
              </el-table-column>
              <el-table-column
                prop="shuoming"
                label="说明">
              </el-table-column>
            </el-table>
        </el-main>
      </el-container>
    </el-container>
</div>
</template>

<script>
//头部组件
import header_ from './header_.vue'    
import celan from './celan.vue'    
export default {
    name: 'faqipay',
    data() {
      return {
        header_:header_,
        celan:celan,
        tableData1: [{
          id: 1,
          date: 'price',
          name: '金额',
          address: 'number',
          shuoming: '必填。交易金额，单位：元，保留两位小数，如8.88'
        }, {
          id: 2,
          date: 'orderName',
          name: '商品名称',
          address: 'string',
          shuoming: '可为空。'
        }, {
          id: 3,
          date: 'payType',
          name: '支付方式',
          address: 'string',
          shuoming: '必填。微信: wx ，支付宝: zfb ，微信赞赏码: zsm'
        }, {
          id: 4,
          date: 'orderNumber',
          name: '订单号',
          address: 'string',       
          shuoming: '必填。订单号，请确保唯一'
        }]
      }
    },
    methods: {

    },
  }
</script>


<style scoped>
.pays h3,.pays p{
  color: #606266;
  font-size: 15px;
  margin-bottom: 12px;
}
.el-container-vh{
  height: 100vh;
}
@media screen and (max-width: 800px) {
  .el-container-vh{
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/faqipay.vue